<template>
<div id="page-carga_mv" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>

            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="Precargar Manifestación de Valor con Archivo M" class="elevation-1 px-5 py-3" >

                    <v-card-text>
                        <v-card-text>
                            <v-form ref="form" lazy-validation>
                                <v-container grid-list-md>
                                    <v-layout wrap>
                                        <v-flex xs12>
                                            <v-text-field label="Selecciona el archivo ZIP" @click='pickFile' v-model='name_file' :rules="[rules.required]" :readonly="true" prepend-icon='attach_file'></v-text-field>
                                            <input type="file" style="display: none" ref="file_input" accept=".zip" @change="onFilePicked" >
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                            </v-form>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>


                        </v-card-actions>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>



    </v-container>
</div>
</template>

<script>
import axios from "axios";
import JSZip from 'jszip'

export default {
    created: function () {
        this.cliente = this.$local_storage.get("id_cliente");
        //this.model.cliente = 52;
    },
    data() {
        return {
            fab: false,

            show_loading: false,
            breadcrumbs: [{
                    text: "Inicio",
                    to: "/home"
                },
         {
                text: "EManifiesto",
                disabled: true,
                to: ""
            },
                {
                    text: "Bitácora M",
                    to: "/mv_bitacora"
                },

                {
                    text: "Carga Archivo M",
                    disabled: true,
                    href: ""
                }
            ],
            title: "",
            modal: false,
            modalApendice: false,
            apendice_items: [],
            columns: [
                "clave",
                "descripcion",
            ],

            update: false,

            file: "",
            cliente: "",
            name_file: "",
            size_file: 0,
            type_file: 'application/zip',

            rules: {
                required: v => !!v || "Este campo es requerido",
            },
            search: "",

        };
    },

    methods: {

        pickFile() {
            this.$refs.file_input.click()
        },

        onFilePicked(e) {
            try {
                this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
                const files = e.target.files;
                var incorrectos = [];
                if (files[0] !== undefined) {

                    this.name_file = files[0].name;
                    this.size_file = files[0].size;
                    this.type_file = files[0].type;

                    if (this.size_file > 1000 * 1000 * 10) {
                        this.$swal({
                            type: "warning",
                            title: "¡Operación no Permitida!",
                            text: "El archivo no debe ser mayor a 10MB.",
                        });
                        this.reset();
                        return false;
                    }

                    var new_zip = new JSZip();                    
                    var thisObj = this;
                    const fr = new FileReader()
                    fr.readAsDataURL(files[0])

                    fr.addEventListener('load', () => {
                        this.file = fr.result; // this is an image file that can be sent to server...          
                        var n = this.file.search("base64,");
                        //Para dejar solo el archivo en base 64 y quitar laparte de "text/plain; base64,"
                        if (n >= 0) {
                            this.file = this.file.substring(n + 7);
                        }
                        
                        new_zip.loadAsync(this.file, {
                                base64: true
                            })
                            .then(function (zip) {
                                
                                zip.forEach(function (relativePath, file) {
                                    if (relativePath.search("__MACOSX/") == -1){                                            
                                        file.async('text').then(function (content) {             
                                            
                                            var splitRelative = relativePath.split("/");                                                    
                                            if(splitRelative.length>0){                                                        
                                                var nombreArchivo = splitRelative[splitRelative.length-1];
                                                var content_lower = content.toString().toLowerCase();

                                                //Verificamos que tenga la 505
                                                if ( !content_lower.split(/\r?\n/).some(linea => linea.startsWith('505|')) ){
                                                    incorrectos.push(nombreArchivo);
                                                } 
                                            }                                            
                                            thisObj.$root.$dialogLoader.hide();                                         
                                            if (incorrectos.length > 0){
                                                thisObj.$swal({
                                                    type: "error",
                                                    title: "¡Operación No Permitida!",
                                                    text: "Existen archivos que no contienen información en la sección 505. Favor de Verificar.",
                                                    footer: "Incorrectos: "+incorrectos.join(", ")
                                                });                                                                                                        
                                                thisObj.reset();
                                            } else {                                                        
                                                var nombre = thisObj.name_file.split(".");
                                                thisObj.uploadFile(files[0], nombre[0]);
                                            }
                                                                                             
                                        });
                                    }                                  
                                                                            
                                });
                                    
                            });
                    });
                                        

                } else {
                    this.$root.$dialogLoader.hide();    
                }
            } catch (error) {
                console.log(error);
                this.$root.$dialogLoader.hide();
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
                    footer: ""
                });
                this.reset();
            }

        },

        uploadFile: function (file, referencia) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');
            var rfc_file = this.$local_storage.get("rfc");
            var usuario_file = this.$local_storage.get("id_usuario");
            var UID =  Math.floor(Math.random() * 9999999);
            var keyFile = rfc_file + "/archivosM/" +  UID + "_" + this.name_file.toUpperCase();
            var thisObj = this;
            var datos = {
                key: keyFile,
                bucket: "production.econnect.ds",
                type: this.type_file
            }

            axios.post(this.$hostname + 's3/upload_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var urlput = res.data.mensaje;
                        //console.log(urlput);
                        axios.put(urlput, file, {headers:{'Content-Type': this.type_file}})
                        .then((res) => {
                            thisObj.submitFile(keyFile);

                        })
                        .catch((error)=>{
                            this.$root.$dialogLoader.hide();
                            this.$swal({
                                type: "error",
                                title: "¡Operación no Permitida!",
                                text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                                footer: '',
                            });
                            console.log(error);
                        });

                    } else {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al cargar el archivo. Favor de comunicarse con soporte.";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    this.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                    this.$root.$dialogLoader.hide();
                });
        },

        submitFile(keyFile) {

            var rfc = this.$local_storage.get("rfc");
            let formData = {
                rfc:rfc,
                key: keyFile
            };

            //axios.post('http://127.0.0.1:7000/leexml/', formData)
            axios.post(this.$hostname + 'bandeja_temporal/leer_archivo_eme/', formData)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {

                        this.$swal({
                            type: "success",
                            title: "¡Operación Exitosa!",
                            text: "El archivo se proceso correctamente.",
                            footer: '',
                        });
                    }

                })
                .catch((error) => {
                    var msg = ''
                    var mostrar = true;
                    if (error.response != null) {
                        if (error.response.data.mensaje != null)
                            msg = error.response.data.mensaje;
                        if (error.response.data.message != null) { //Si entra aqui significa que regreso un TimeOut de Amazon Api, recibirá notificacion cuando temrine
                            mostrar = false;
                            this.$swal({
                                type: "success",
                                title: "¡Operación Exitosa!",
                                text: "El archivo se proceso correctamente",
                                footer: '',
                            });
                            msg = error.response.data.message;
                        }
                    }
                    if (mostrar) {
                        this.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un error al cargar el archivo",
                            footer: msg,
                        });
                        console.log(error);
                    }

                }).then(() => {
                    this.$root.$dialogLoader.hide();
                    this.reset();
                });

        },
        reset() {
            const input = this.$refs.file_input;
            input.type = 'text';
            input.type = 'file';
            this.name_file = '';
        },

    }
};
</script>
